import axios, { AxiosError, AxiosResponse } from "axios";
import * as Sentry from "@sentry/react";

const commonInterceptor = (client: any) => {
  client.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
      const axiosError = error as AxiosError;
      if (axios.isCancel(error)) {
        return Promise.reject(error); // Don't report or handle cancellation errors
      }
      if (axiosError.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        Sentry.captureException(
          new Error(
            `Error ${axiosError.response.status}: ${JSON.stringify(
              axiosError.response.data
            )}`
          )
        );
      } else if (axiosError.request) {
        // The request was made but no response was received
        console.log(axiosError.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        Sentry.captureException(new Error(axiosError.message));
      }
      Sentry.captureException(error);
      return Promise.reject(error);
    }
  );
};

export const convAiClient = axios.create({
  baseURL: "/conv-ai",
});

export const taoCmsClient = axios.create({
  baseURL: "/tao-cms",
});

commonInterceptor(convAiClient);
commonInterceptor(taoCmsClient);
